import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[appExpandTruncate]',
  standalone: false,
})
export class ExpandTruncateDirective {
  private full = '';
  private expanded = false;

  @Input() appExpandTruncateLimit = 10;

  @Input('appExpandTruncate')
  set text(v: string | null | undefined) {
    this.full = v ?? '';
    this.expanded = false;
    this.render();
  }

  constructor(private el: ElementRef<HTMLElement>) {
    const e = this.el.nativeElement;
    e.classList.add('whitespace-nowrap', 'cursor-pointer', 'truncate');
  }

  @HostListener('click', ['$event'])
  click(ev: MouseEvent) {
    ev.stopPropagation();
    this.expanded = !this.expanded;
    this.render();
  }

  private render() {
    const e = this.el.nativeElement;
    const limit = Number(this.appExpandTruncateLimit) || 10;

    const shown = this.expanded
      ? this.full
      : (this.full.length > limit ? this.full.slice(0, limit) + '...' : this.full);

    e.textContent = shown;
    e.classList.toggle('truncate', !this.expanded);
    e.classList.toggle('overflow-visible', this.expanded);
  }
}
